import { render, staticRenderFns } from "./OrderLayout.vue?vue&type=template&id=3c47e49c&scoped=true&"
import script from "./OrderLayout.vue?vue&type=script&lang=js&"
export * from "./OrderLayout.vue?vue&type=script&lang=js&"
import style0 from "./OrderLayout.vue?vue&type=style&index=0&id=3c47e49c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47e49c",
  null
  
)

export default component.exports